var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section-title"},[_c('h4',{staticClass:"p-3 mb-2"},[_c('span',[_vm._v("Your Documents")])])])])
}]

export { render, staticRenderFns }